import React from 'react';

import classname from '@search/classname/src';

import './NotFoundPage.css';

const cn = classname.bind(null, 'NotFoundPage');

export const NotFoundPage = () => (
    <div className={cn()}>
        <div className={cn('nf-bg')}></div>

        <div className={cn('nf-particles')}>
            <span className={cn('particle p1')}></span>
            <span className={cn('particle p2')}></span>
            <span className={cn('particle p3')}></span>
            <span className={cn('particle p4')}></span>
            <span className={cn('particle p5')}></span>
            <span className={cn('particle p6')}></span>
        </div>

        <div className={cn('nf-content')}>
            <h1 className={cn('nf-title')}>404</h1>
            <p className={cn('nf-text')}>Упс… Такой страницы здесь нет.</p>
            <a href='https://m2.ru/' className={cn('nf-btn')}>Вернуться на главную</a>
        </div>
    </div>
);
